import React from "react"
import { CreateMemberForm } from "@/components/forms"
import type { InviteFirstMemberStepProps } from "./InviteFirstMemberStep.types"

export const InviteFirstMemberStep: React.FunctionComponent<
  InviteFirstMemberStepProps
> = ({ onSuccess }) => {
  return <CreateMemberForm onSuccess={() => onSuccess()} />
}
